module.exports = __webpack_public_path__ + "images/instructor-lauren-newbould-mobile.webp";